import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IListCentroCusto } from '../models/list-centro-custo';

@Injectable({
  providedIn: 'root'
})
export class ListCetroCustoService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}CostCenter`;

  constructor(private readonly toastService: ToastService, private readonly httpClient: HttpClient) {
    super(toastService);
  }

  getCentroCusto(companyId?: string): Observable<ResponseDefault<IListCentroCusto[]>> {
    let params = new HttpParams();

    if (companyId) {
      console.log(companyId);
      params = params.append('companyId', companyId);
    }
    return this.httpClient.get<ResponseDefault<IListCentroCusto[]>>(`${this.apiUrl}/ListActiveAsync`, { params });
  }
}
